export const OIDC_RETURN_PATH = "oidc-verify";
export const IDIN_RETURN_PATH = "capture";
export const OIDC_RETURN_URL_PARAMETER_NAME = "returnUrl";
export const SIGNICAT_VALIDATION_CHECKS_ERROR_MESSAGE_CODE = "SIGNICAT_VALIDATION_CHECKS_ERROR";
